import { createActions } from 'redux-actions';

import { Dispatch } from 'react';
import Auth from '../../api/auth';
import paymentsApi from '../../api/paymentsApi';
import { getActionOptions } from '../../lib/reduxActionsUtils';
import { ACTION_PREFIX, actionTypes } from './constants';

export const {
  confirmPayPending,
  confirmPayFulfilled,
  confirmPayRejected,
  declineCheckoutPending,
  declineCheckoutFulfilled,
  declineCheckoutRejected,
  getLoanAgreementDetailsPending,
  getLoanAgreementDetailsFulfilled,
  getLoanAgreementDetailsRejected,
} = createActions(
  actionTypes.CONFIRM_PAY_PENDING,
  actionTypes.CONFIRM_PAY_FULFILLED,
  actionTypes.CONFIRM_PAY_REJECTED,
  actionTypes.DECLINE_CHECKOUT_PENDING,
  actionTypes.DECLINE_CHECKOUT_FULFILLED,
  actionTypes.DECLINE_CHECKOUT_REJECTED,
  actionTypes.GET_LOAN_AGREEMENT_DETAILS_PENDING,
  actionTypes.GET_LOAN_AGREEMENT_DETAILS_FULFILLED,
  actionTypes.GET_LOAN_AGREEMENT_DETAILS_REJECTED,
  getActionOptions(ACTION_PREFIX)
);

const confirmPay = (checkOutId: string, buyerAccountId: string) => (dispatch: Dispatch<any>) => {
  dispatch(confirmPayPending());
  return paymentsApi
    .confirmPay(checkOutId, buyerAccountId)
    .then((response) => {
      Auth.logout();
      return dispatch(confirmPayFulfilled(response));
    })
    .catch((error: any) => {
      return dispatch(confirmPayRejected(error));
    });
};

const getLoanAgreementDetails = (checkOutId: string, buyerAccountId: string) => async (dispatch: Dispatch<any>) => {
  dispatch(getLoanAgreementDetailsPending());
  try {
    const response = await paymentsApi.getLoanAgreementDetails(checkOutId, buyerAccountId);
    return dispatch(getLoanAgreementDetailsFulfilled(response));
  } catch (error) {
    return dispatch(getLoanAgreementDetailsRejected(error));
  }
};

const declineCheckOut = (checkOutId: string) => (dispatch: Dispatch<any>) => {
  dispatch(declineCheckoutPending());
  return paymentsApi
    .declineCheckOut(checkOutId)
    .then((response) => {
      Auth.logout();
      return dispatch(declineCheckoutFulfilled(response));
    })
    .catch((error: any) => {
      return dispatch(declineCheckoutRejected(error));
    });
};

export default {
  confirmPay,
  declineCheckOut,
  getLoanAgreementDetails,
};
